/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterView } from './FilterView';
import {
    FilterViewFromJSON,
    FilterViewFromJSONTyped,
    FilterViewToJSON,
    FilterViewToJSONTyped,
} from './FilterView';

/**
 * 
 * @export
 * @interface CreateFilterView201Response
 */
export interface CreateFilterView201Response {
    /**
     * 
     */
    data?: FilterView;
}

/**
 * Check if a given object implements the CreateFilterView201Response interface.
 */
export function instanceOfCreateFilterView201Response(value: object): value is CreateFilterView201Response {
    return true;
}

export function CreateFilterView201ResponseFromJSON(json: any): CreateFilterView201Response {
    return CreateFilterView201ResponseFromJSONTyped(json, false);
}

export function CreateFilterView201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFilterView201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FilterViewFromJSON(json['data']),
    };
}

export function CreateFilterView201ResponseToJSON(json: any): CreateFilterView201Response {
    return CreateFilterView201ResponseToJSONTyped(json, false);
}

export function CreateFilterView201ResponseToJSONTyped(value?: CreateFilterView201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FilterViewToJSON(value['data']),
    };
}

